import React, { useEffect, useState, useMemo } from 'react';
import { Space, Table, Tag, Button, Image, Card, Input, Flex, Select, Modal, Form, Descriptions, Popconfirm } from 'antd';
import { useNavigate, useParams } from "react-router";
import { DeleteOutlined, EditOutlined, EyeOutlined } from '@ant-design/icons';
import { useForm, useWatch } from "antd/es/form/Form";
import UserService from 'services/collaborator_user';
import { useApp } from "contexts/app";
import { useAuth } from "contexts/auth";
import _ from "lodash"
import { formatCurrency } from "utils/number"
import { formatDate } from "utils/date"
import { getBankName } from "pages/website_setting/BankList";
import InputNumber from "components/input-number"
const { Search } = Input;
const service = new UserService();


const Transactions = ({ id, onChange }) => {




    const [transactions, setTransactions] = useState([])

    const { showLoading, showNotify } = useApp();
    useEffect(() => {
        load();
    }, [id])
    const load = async () => {


        var lst = await service.getTransactions(id);
        setTransactions(lst)
    }

    const deleteTransaction = async (tranID) => {
        await service.deleteTransaction(tranID);
        await load();
        if(onChange){
            onChange();
        }
    }



    return (
        <>

            <Card title="Lịch sử" size='small'>
                <Table columns={[
                    {


                        title: "Nội dung",

                        render: (_, record) => {
                            return (

                                <Space size="middle">

                                    {record.type == "withdraw" &&
                                        <>Thanh toán hoa hồng</>
                                    }


                                    {record.type == "order" &&
                                        <>Hoa hồng đơn hàng h<a href={`/order/${record.order_id}`}> {record.order_id}</a></>
                                    }

                                </Space>
                            )

                        }



                    },

                    {


                        title: "Số tiền",

                        render: (_, record) => {
                            return (

                                <Space size="middle">

                                    {formatCurrency(record.amount)}
                                </Space>
                            )

                        }



                    },


                    {


                        title: "",

                        render: (_, record) => {
                            return (

                                <Space size="middle">
                                    <Popconfirm
                                        title="Xoá"
                                        description="Bạn có chắc chắn muốn xoá?"
                                        onConfirm={e => deleteTransaction(record.id)}
                                        onCancel={null}
                                        okText="Yes"
                                        cancelText="No"
                                    >
                                        <Button danger>Xoá</Button>
                                    </Popconfirm>

                                </Space>
                            )

                        }



                    }
                ]} dataSource={transactions} />

            </Card>


        </>

    )
}


export default Transactions;